import { render, staticRenderFns } from "./MatchSale.vue?vue&type=template&id=16d7303c&scoped=true"
import script from "./MatchSale.vue?vue&type=script&lang=js"
export * from "./MatchSale.vue?vue&type=script&lang=js"
import style0 from "./MatchSale.vue?vue&type=style&index=0&id=16d7303c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7303c",
  null
  
)

export default component.exports